import React, { useEffect, useState } from 'react'
import apiClient from '../../utils/api/apiClient'
import { APIEndpoints } from '../../utils/api/apiConfig'
import { getErrorMessageFromApiResponse } from '../../utils/api/apiUtils'
import QrModal from '../Modals/QrModal'
import { playScanErrorSound, playScanOkSound } from '../../utils/playSounds'
import { t } from 'i18next'
import useStores from '../../stores/useStore'
import { isEmptyGuid } from '../../utils/emptyGuid'
import { isEmptyStr } from '../../utils/objectutils'

const InventoryArticleScan = ({ handleClose, employeeId }) => {
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(null)
  const [error, setError] = useState(null)
  const [scannedArticle, setScannedArticle] = useState(null)
  const { inventoryStore } = useStores()
  const [rfidNotFoundList, setRfidNotFoundList] = useState([])
  const [rfidDuplicateList, setRfidDuplicateList] = useState([])
  const [rfidSuccess, setRfidSuccess] = useState(false)
  const handleResult = async (result) => {
    if (loading || isEmptyStr(result)) {
      return false
    }
    playScanOkSound()
    setSuccess(null)
    setError(null)
    setScannedArticle(null)
    setLoading(true)
    try {
      let scanResponse = await apiClient.getJson(
        APIEndpoints.bussinesspartnerInventoryScan(employeeId, result)
      )
      if (
        scanResponse.isWithSizes &&
        isEmptyGuid(scanResponse.articleVariant.id)
      ) {
        throw new Error(t('inventory:invalidScanResult'))
      }
      setScannedArticle(scanResponse)
      await inventoryStore.addScannedArticle(scanResponse)
      setSuccess(t('inventory:addedPosition'))
      setRfidSuccess(true)
      return true
    } catch (e) {
      let errorMsg = getErrorMessageFromApiResponse(e)
      if (errorMsg.toLowerCase() === 'no results found') {
        errorMsg = t('inventory:invalidScanResult')
        setRfidNotFoundList((prev) => [...prev, result])
      }
      if (
        errorMsg.trim().toLowerCase() ===
        t('inventory:alreadySelectedAlert').trim().toLowerCase()
      ) {
        setRfidDuplicateList((prev) => [...prev, result])
      }
      setError(errorMsg)
      playScanErrorSound()
      return false
    } finally {
      setLoading(false)
    }
  }
  
  useEffect(() => {
    let timeout = null
    if (success || error) {
      timeout = setTimeout(() => {
        setSuccess(null)
        setError(null)
        setScannedArticle(null)
        setRfidSuccess(false)
      }, 3000)
    }
    return () => {
      clearTimeout(timeout)
    }
  }, [success, error])

  return (
    <div>
      <QrModal
        title={t('productsOverview:articleScan')}
        handleClose={handleClose}
        qrModalError={error}
        qrModalSuccess={success}
        scannedArticle={scannedArticle}
        handleResult={(r) => handleResult(r)}
        isLoading={loading}
        rfidNotFoundList={rfidNotFoundList}
        setRfidNotFoundList={setRfidNotFoundList}
        rfidDuplicateList={rfidDuplicateList}
        setRfidDuplicateList={setRfidDuplicateList}
        rfidSuccess={rfidSuccess}
        setRfidSuccess={setRfidSuccess}
      ></QrModal>
    </div>
  )
}

export default InventoryArticleScan
